import { render } from "./CadastrarChamadoCrm.vue?vue&type=template&id=8779c364"
import script from "./CadastrarChamadoCrm.vue?vue&type=script&lang=js"
export * from "./CadastrarChamadoCrm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__